import type {ExtraDeliveryPaymentSuccessState} from '../types';

import {dateToReadableDate} from '@date-picker';
import {Button, Divider} from '@ds/components';
import {PageLayout} from '@ds/layout';
import paymentSuccess from 'assets/images/pin-payment-success.svg';
import {useLocation, useNavigate} from 'react-router-dom';

import ExtraDeliveryInfoRow from '../components/common/ExtraDeliveryInfoRow/ExtraDeliveryInfoRow';
import ExtraDeliveryStatus from '../components/common/ExtraDeliveryStatus/ExtraDeliveryStatus';
import {EXTRA_DELIVERY_ROUTES} from '../constants';

const ExtraDeliveryPaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const data = (state ?? {}) as ExtraDeliveryPaymentSuccessState;

  return (
    <PageLayout
      footerPosition="static"
      footer={
        <Button
          fullWidth
          variant="fill"
          color="secondary"
          onClick={() => navigate(EXTRA_DELIVERY_ROUTES.list)}
        >
          متوجه شدم
        </Button>
      }
    >
      <header className="px-4 py-6 text-center">
        <img className="mx-auto" src={paymentSuccess} alt="" aria-hidden />
        <h1 className="mt-4 text-subtitle-md text-neutral-fg">
          سرویس محدوده پوشش‌دهی با موفقیت فعال شد.
        </h1>
        <p className="mt-1 text-body-sm text-gray-34">
          مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.
        </p>
      </header>
      <Divider className="bg-gray-02" size={8} />
      <section className="px-4">
        <ExtraDeliveryInfoRow title="وضعیت" value={<ExtraDeliveryStatus value={data.state} />} />
        <ExtraDeliveryInfoRow
          title="تاریخ شروع"
          value={
            data.start_time
              ? dateToReadableDate({
                  date: data.start_time,
                  day: true,
                  month: true,
                  year: true
                })
              : ''
          }
        />
        <ExtraDeliveryInfoRow title="نوع کمپین" value="تکرار شونده" hasBorder={false} />
      </section>
    </PageLayout>
  );
};

export default ExtraDeliveryPaymentSuccess;
